import React from "react";

export default function EmptyState({ icon: Icon, title, text, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6" data-testid="empty-state">
      {Icon && (
        <div className="h-16 w-16 rounded-full bg-brand-orangeSoft text-brand-orange flex items-center justify-center mb-4">
          <Icon className="h-7 w-7" strokeWidth={2} />
        </div>
      )}
      <h3 className="font-display text-xl text-brand-navy">{title}</h3>
      {text && <p className="mt-2 text-sm text-slate-500 max-w-xs">{text}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
